module.exports = __webpack_public_path__ + "static/img/md.e98e2477.png";